/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Button, Row, Col, Modal, Form, Spinner, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
import { Link, Redirect } from 'react-router-dom';

//project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { invoiceDetail, invoiceSendEmail, updateShipping, transactionAdd, updateInvoice, transactionHistory, buyerlinkurl, saledetail,invoicePrintPdf,invoiceitemreceiptmethod } from 'shared/settings/apiconfig';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import { capitalizeFirstLetter } from 'shared/utils';

//style imports
import './InvoiceView.scss';
import { FEE_TYPE_LIST } from 'shared/settings/config';
import { responseCodeAndStatus } from './DeclinedCardStatus';
import { NoData } from 'features/components/redirect/NoData';

const decimalTypes = ['amountpaid'];
/**
 * this page is used to view invoice
 * 
 * @param props
 * 
 * 
 * @param invoiceid
 * 
 * @return html to render invoice view
 * 
**/

export class InvoiceView extends Component {
    status = { 'paid': 'fa-check-circle', 'unpaid': 'fa-times-circle' }
    constructor(props) {
        super(props);
        this.TransactionType = ["Cash", "Card", "Check", "Other"]
        this.paymentType = ["Credit"]
        this.itemReceiptMethods = [];
        this.invoiceItemReceiptMethod = null;
        this.approveBack = false
        this.state = {
            isScreenFrom: props?.location?.state?.from,
            DisplayTrackingid: "",
            printPdf: false,
            mirstatus: this.props?.location?.state?.mirstatus,
            dgstatus: this.props?.location?.state?.dgstatus,
            form: {
                enableEdit: false,
                id: this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1),
                invoiceViewId: this.props.location.pathname.slice(this.props.location.pathname.lastIndexOf('/') + 1),
                billingto: {
                    name: '',
                    addressto1: '',
                    addressto2: '',
                    cityState: '',
                    countryZipcode: '',
                    email: '',
                    phonenumber: ''
                },
                billingfrom: {
                    contactname: '',
                    address1: '',
                    address2: '',
                    cityState: '',
                    countryZipcode: '',
                    contactemail: '',
                    contactmobile: ''
                },
                shippingto: {
                    address: '',
                    cityState: '',
                    countryZipcode: '',
                    showShippingAddress: false
                },
                trackingid: '',
                items: [],
                total: '',
                buyerspremium: '',
                tax: '',
                grossamount: '',
                amountdue: '',
                status: '',
                invoicenumber: '',
                applytaxonbp: '',
                autoDebitStatus: '',
                totaltax: '',
                totaltaxamount: '',
                totalbp: '',
                totalbpamount: '',
                taxonBPamount: '',
                totalgrossamount: '',
                totalamount: '',
                invoicemessage: '',
                createddate: '',
                timezone: '',
                invoiceitemreceiptmethod: '',
                bidderacceptance: '',
                createdtype: '',
                selectedService: [],
                child_invoice: [],
                masterId: "",
                masterInvoiceNo: "",
                totalInvoiceAmount : '' ,
                totalInvoicePendingAmount : '' ,
                invoiceStatusAll : '' ,
                totaltaxonbpamount: '',
                saleshippingsaint: ''
            },
            shippedForm: {
                trackingid: '',
                description: '',
                valid: false
            },
            paidForm: {
                transactionType: this.TransactionType[2],
                transactionID: '',
                amountpaid: '',
                description: '',
                paymentType: this.paymentType[0],
                receiptmethod: '',
                valid: false,
            },
            errors: {
                transactionID: '',
                amountpaid: '',
                description: '',
            },
            windowWidth: window.innerWidth,
            loading: false,
            paidModal: false,
            shippedModal: false,
            isPaidData: false,
            isShippedData: false,
            updateInvoiceData: {
                parentinvoiceid: "",
                invoiceamount: "",
                details: "",
                buyerid: "",
                type: "",
                saleid: ""
            },
            invoiceStatus: { show: false, type: '', message: '' },
            addOnInvoiceStatus: { show: false, type: '', message: '' },
            modalStatus: { show: false, type: '', message: '' },
            transactionData: [],
            transactionModal: false,
            errorpageredirect: false,
            childInvoice: "",
            totalInvoiceAmount : 0,
            totalInvoicePendingAmount : 0,
            totalInvoiceAmountPaid : 0,
            irmModel: false,
            itemReceiptValue: '',
            validirm: false,
            invoiceview: 0,
            shippingCheckboxData: [],
            pickupCheckboxData: [],
            deliveryCheckboxData: [],
            errorType: ''
        }
        this.stateCopy = {...this.state};

    }

    componentDidMount() {
        if (this.state.childInvoice === this.state.form.id) {
            this.setState({
                childInvoice: ""
            })
        }
        window.addEventListener('resize', this.updateDimensions);
        this.getInvoiceData();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        if (this.props.location?.state?.state?.name === 'Saledashboard') {
        }
        else {
            window.removeEventListener('popstate', this.onBack);
        }
    }

    /* Detect window width */
    updateDimensions = () => {
        this.setState({ windowWidth: window.innerWidth });
    };
    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }

    /* Get invoice data */
    getInvoiceData = () => {
        this.setState({ loading: true });
        axios.get(getSellerUrl(`${invoiceDetail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(async response => {
                if (response.status === 200) {
                    if (response.data.status === 'success') {
                        let data = response.data.data[0];
                        this.setState({
                            invoiceview: data.invoiceview
                        })
                       if(data.masterinvoiceid && (data.invoicestatus).toLowerCase() != 'void'){
                            this.setState({
                                form: {
                                    ...this.state.form,
                                    id: data.masterinvoiceid,
                                    totalInvoiceAmount : 0,
                                    totalInvoicePendingAmount : 0,
                                    totalInvoiceAmountPaid : 0
                                }  
                            })
                            await this.getInvoiceData()
                        } else {
                            if(this.state.form.invoiceViewId == data.id && data.pendingamount ===  data.invoiceamount){
                                this.setState({
                                    form: {
                                        ...this.state.form,
                                       enableEdit: true
                                    }
                                });
                            }
                            this.getTransactionData();
                            let invoiceData = JSON.parse(response.data.data[0].details);
                            let billingfromCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ', ' : '';
                            let billingfromCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                            let billingtoCityDelimiter = invoiceData.billingto.city && invoiceData.billingto.state ? ', ' : '';
                            let billingtoCountryDelimiter = invoiceData.billingto.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                            let shippingtoCityDelimiter = invoiceData.billingfrom.city && invoiceData.billingfrom.state ? ', ' : '';
                            let shippingtoCountryDelimiter = invoiceData.billingfrom.country && invoiceData.billingfrom.zipcode ? ', ' : '';
                            let selectedService = [];
                            FEE_TYPE_LIST.map((item) => {
                                if (invoiceData[item.key]) {
                                    selectedService.push({
                                        ...item,
                                        amount: invoiceData[item.key],
                                        remark: invoiceData[item.key + "remark"],
                                    })
                                }
                                return item
                            })
                            let child_invoice = data["child_invoice"] ? data["child_invoice"] : []
                            child_invoice = child_invoice.map((item) => {
                                if(this.state.form.invoiceViewId == item.id && item.pendingamount == item.invoiceamount){
                                    this.setState({
                                        form: {
                                            ...this.state.form,
                                           enableEdit: true
                                        }
                                    });
                                }
                                this.state.form.totalInvoiceAmount = Number(this.state.form.totalInvoiceAmount) + Number(item.invoiceamount);
                                this.state.form.totalInvoicePendingAmount = Number(this.state.form.totalInvoicePendingAmount) + Number(item.pendingamount);
                                let child_invoice_details = JSON.parse(item.details)
                                child_invoice_details["billingto"] = {
                                    name: child_invoice_details["billingto"]["firstname"],
                                    address1: child_invoice_details["billingto"]["address1"],
                                    cityState: (`${child_invoice_details["billingto"]["city"] ? child_invoice_details["billingto"]["city"] : ""}
                                    ${child_invoice_details["billingto"]["state"] ? child_invoice_details["billingto"]["state"] : ""}`),
                                    countryZipcode: (`${child_invoice_details["billingto"]["country"] ? child_invoice_details["billingto"]["country"] : ""}
                                    ${child_invoice_details["billingto"]["zipcode"] ? child_invoice_details["billingto"]["zipcode"] : ""}`),
                                    email: child_invoice_details["billingto"]["email"],
                                    phonenumber: child_invoice_details["billingto"]["mobile"],
                                }
                                child_invoice_details["billingfrom"] = {
                                    contactname: child_invoice_details["billingfrom"]["contactname"],
                                    address1: child_invoice_details["billingfrom"]["address1"],
                                    cityState: (`${child_invoice_details["billingfrom"]["city"] ? child_invoice_details["billingfrom"]["city"] : ""}
                                    ${child_invoice_details["billingfrom"]["state"] ? child_invoice_details["billingfrom"]["state"] : ""}`),
                                    countryZipcode: (`${child_invoice_details["billingfrom"]["country"] ? child_invoice_details["billingfrom"]["country"] : ""}
                                    ${child_invoice_details["billingfrom"]["zipcode"] ? child_invoice_details["billingfrom"]["zipcode"] : ""}`),
                                    contactemail: child_invoice_details["billingfrom"]["contactemail"],
                                    contactmobile: child_invoice_details["billingfrom"]["contactmobile"],
                                }
                                let child_invoice_selectedService = []
                                FEE_TYPE_LIST.map((item) => {
                                    if (child_invoice_details[item.key]) {
                                        child_invoice_selectedService.push({
                                            ...item,
                                            amount: child_invoice_details[item.key],
                                            remark: child_invoice_details[`${item.key}remark`],
                                        })
                                    }
                                    return item
                                })
                                return ({
                                    ...item,
                                    details: child_invoice_details,
                                    selectedService: child_invoice_selectedService,
                                })
                            })

                            let shippingData = []
                            let pickupData = []
                            let deliveryData = []
                            invoiceData.items.map((elem) => {
                                if(elem.bidderirm == "shipping") {
                                    shippingData.push({id: elem.id, option: elem.title});
                                } else if(elem.bidderirm == "pickup") {
                                    pickupData.push({id: elem.id, option: elem.title});
                                }else if(elem.bidderirm == "delivery") {       
                                    deliveryData.push({id: elem.id, option: elem.title});
                                }
                            })
                            this.setState({
                                shippingCheckboxData: [...shippingData],
                                pickupCheckboxData: [...pickupData],
                                deliveryCheckboxData: [...deliveryData]
                            })

                            this.setState({
                                DisplayTrackingid: data.trackshippingid ? data.trackshippingid : '',
                                form: {
                                    ...this.state.form,
                                    billingto: {
                                        ...this.state.form.billingto,
                                        name: invoiceData.billingto.firstname + ' ' + invoiceData.billingto.lastname,
                                        addressto1: (invoiceData.billingto.address1 ? invoiceData.billingto.address1 : '') + (billingtoCityDelimiter) + (invoiceData.billingto.address2 ? invoiceData.billingto.address2 + "," : ''),
                                        cityState: (invoiceData.billingto.city ? invoiceData.billingto.city : '') + (billingtoCityDelimiter) + (invoiceData.billingto.state ? invoiceData.billingto.state : ''),
                                        countryZipcode: (invoiceData.billingto.country ? invoiceData.billingto.country : '') + (billingtoCountryDelimiter) + (invoiceData.billingto.zipcode ? invoiceData.billingto.zipcode : ''),
                                        email: invoiceData.billingto.contactemail ? invoiceData.billingto.contactemail : invoiceData.billingto.email ? invoiceData.billingto.email : '',
                                        phonenumber: invoiceData.billingto.contactmobile ? invoiceData.billingto.contactmobile : invoiceData.billingto.mobile ? invoiceData.billingto.mobile : '',
                                    },
                                    billingfrom: {
                                        ...this.state.form.billingfrom,
                                        contactname: invoiceData.billingfrom.contactname ? invoiceData.billingfrom.contactname : '',
                                        address1: (invoiceData.billingfrom.address1 ? invoiceData.billingfrom.address1 : '') + ',' + (invoiceData.billingfrom.address2 ? invoiceData.billingfrom.address2 + "," : ''),
                                        cityState: (invoiceData.billingfrom.city ? invoiceData.billingfrom.city : '') + (billingfromCityDelimiter) + (invoiceData.billingfrom.state ? invoiceData.billingfrom.state : ''),
                                        countryZipcode: (invoiceData.billingfrom.country ? invoiceData.billingfrom.country : '') + (billingfromCountryDelimiter) + (invoiceData.billingfrom.zipcode ? invoiceData.billingfrom.zipcode : ''),
                                        contactemail: invoiceData.billingfrom.contactemail ? invoiceData.billingfrom.contactemail : invoiceData.billingfrom.email ? invoiceData.billingfrom.email : '',
                                        contactmobile: invoiceData.billingfrom.contactmobile ? invoiceData.billingfrom.contactmobile : invoiceData.billingfrom.mobile ? invoiceData.billingfrom.mobile : '',
                                    },
                                    shippingto: {
                                        ...this.state.form.shippingto,
                                        address: (invoiceData?.shippingto?.address1 ? invoiceData?.shippingto?.address1 + ', ' : '') + (invoiceData?.shippingto?.address2 ? invoiceData?.shippingto?.address2 + ', ' : ''),
                                        cityState: (invoiceData?.shippingto?.city ? invoiceData?.shippingto?.city : '') + (shippingtoCityDelimiter) + (invoiceData?.shippingto?.state ? invoiceData?.shippingto?.state : ''),
                                        countryZipcode: (invoiceData?.shippingto?.country ? invoiceData?.shippingto?.country : '') + (shippingtoCountryDelimiter) + (invoiceData?.shippingto?.zipcode ? invoiceData?.shippingto?.zipcode : ''),
                                        showShippingAddress: invoiceData?.shippingto ? true : false
                                    },
                                    trackingid: data.trackshippingid ? data.trackshippingid : '',
                                    // shippinghandling: invoiceData.shippinghandling,
                                    selectedService,
                                    items: invoiceData.items,
                                    status: data.invoicestatus,
                                    invoiceamount: data.invoiceamount,
                                    pendingamount: data.pendingamount,
                                    invoicenumber: data.invoicenumber,
                                    applytaxonbp: data.applytaxonbp,
                                    autoDebitStatus: response.data.data[0].autoDebitStatus ? response.data.data[0].autoDebitStatus : '',
                                    invoicemessage: invoiceData.invoicemessage ? JSON.parse(invoiceData.invoicemessage).content.body : '',
                                    createddate: data.createddate ? data.createddate : '',
                                    timezone: data.timezonename ? data.timezonename : '',
                                    bidderacceptance: data.bidderacceptance ? data.bidderacceptance : '',
                                    createdtype : data.createdtype ? data.createdtype : '',
                                    // additionalamount: invoiceData.additionalamount ? invoiceData.additionalamount : '',
                                    invoiceitemreceiptmethod: data.invoiceitemreceiptmethod ? data.invoiceitemreceiptmethod : '',
                                    child_invoice: child_invoice,
                                    masterId: data.masterinvoiceid ? data.masterinvoiceid : "",
                                    masterinvoiceid: data.masterinvoiceid ? data.masterinvoiceid : "---",
                                    masterinvoicenumber: data.masterinvoicenumber ? data.masterinvoicenumber : "---",
                                    totalInvoiceAmount : data.invoiceamount ? (Number(this.state.form.totalInvoiceAmount) + Number(data.invoiceamount)) : Number(this.state.form.totalInvoiceAmount),
                                    totalInvoiceAmountPaid : this.calculatePaymentReceived(data.invoiceamount, data.pendingamount),
                                    totalInvoicePendingAmount : data.pendingamount ? (Number(this.state.form.totalInvoicePendingAmount) + Number(data.pendingamount)) : Number(this.state.form.totalInvoicePendingAmount),
                                    invoiceStatusAll : invoiceData.invoiceStatus,
                                    saleshippingsaint : data.saleshippingsaint,
                                },
                                paidForm: {
                                    ...this.state.paidForm,
                                    trackshippingid: data.trackshippingid != null ? data.trackshippingid : ""
                                },
                                shippedForm: {
                                    trackingid: data.trackshippingid != null ? data.trackshippingid : "",
                                    description: "shippingnotes" in data && data.shippingnotes != null ? data.shippingnotes : "",
                                    valid: false
                                },
                                additionalnotes: data.additionalnotes ? data.additionalnotes : '',
                                loading: false,
                                isShippedData: data.trackshippingid != null ? true : false,
                                updateInvoiceData: {
                                    ...this.state.updateInvoiceData,
                                    parentinvoiceid: data.id != null ? data.id : "",
                                    invoiceamount: data.invoiceamount != null ? data.invoiceamount : "",
                                    details: data.details != null ? data.details : "",
                                    buyerid: data.buyerid != null ? data.buyerid : "",
                                    type: data.type != null ? data.type : "",
                                    saleid: data.saleid != null ? data.saleid : ""
                                }

                            }, () => {
                                this.calculateTotal();
                                this.setresceiptData(data)
                                // this.getSaleDetails();
                            });
                        }
                    }
                }
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    }

    // get payment received
    calculatePaymentReceived = (invoiceAmount, pendingAmount) => {
        let totalInvoiceAmt = Number(this.state.form.totalInvoiceAmount)
        let totalPendingAmt = Number(this.state.form.totalInvoicePendingAmount)
        if(invoiceAmount) {
            totalInvoiceAmt += Number(invoiceAmount)
        }
        if(pendingAmount) {
            totalPendingAmt += Number(pendingAmount)
        }
        return totalInvoiceAmt - totalPendingAmt
    }

    // to get sale item receipt method details
    // getSaleDetails = () => {
    //     let field = ['saleitemreceiptmethod'];
    //     axios.post(getSellerUrl(`${saledetail}/${this.state.updateInvoiceData.saleid}`), JSON.stringify({ field: field }), getSellerHeaders())
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 response = response.data.data[0];
    //                 this.setresceiptData(response)
    //             }
    //         })
    //         .catch((error) => {
    //         });

    // };

    // to set sale item receipt method details
    setresceiptData(response) {
        try {
            this.itemReceiptMethods = [];
            this.invoiceItemReceiptMethod = typeof response['invoiceitemreceiptmethod'] === "string" ? response['invoiceitemreceiptmethod'].charAt(0).toUpperCase() + response['invoiceitemreceiptmethod'].slice(1) : response['invoiceitemreceiptmethod'];
            if (response['avalitemreceiptmethod']) {
                let availReceiptMethod = JSON.parse(response['avalitemreceiptmethod']);
                let availMethodObj = Array.isArray(availReceiptMethod) ? availReceiptMethod[0] : availReceiptMethod;
                let keys = Object.keys(availMethodObj);
                keys.forEach(key => {
                    if (availMethodObj[key]) {
                        this.itemReceiptMethods.push(key.charAt(0).toUpperCase() + key.slice(1));
                    }
                });
            }

            // if (response) {
            //     if (response['saleitemreceiptmethod']) {
            //         let salereceipt = response['saleitemreceiptmethod']
            //         let ispickup = salereceipt ? this.getBool(JSON.stringify(JSON.parse(salereceipt)['pickup'])) : false
            //         let isshipping = salereceipt ? this.getBool(JSON.stringify(JSON.parse(salereceipt)['shipping'])) : false
            //         let isdelivery = salereceipt ? this.getBool(JSON.stringify(JSON.parse(salereceipt)['delivery'])) : false
            //         let tempReceipt = []
            //         if (ispickup) {
            //             tempReceipt.push('Pickup')
            //         }
            //         if (isshipping) {
            //             tempReceipt.push('Shipping')
            //         }
            //         if (isdelivery) {
            //             tempReceipt.push('Delivery')
            //         }
            //         this.itemReceiptMethods = tempReceipt
            //     }
            // }
        } catch (e) {

        }
    }

    // properly convert to boolean (Standard method)
    getBool(val) {
        try {
            if (val)
                return !!JSON.parse(String(val).toLowerCase());
            else
                return false
        } catch (e) {
            return false
        }
    }
    /* Get transaction history data */
    getTransactionData = () => {
        const data = {
            filter: [
                { field: 'invoiceid', value: Number(this.state.form.id), op: '=', join: 'AND' }
            ]
        };
        this.setState({ pageLoading: true });

        axios.post(getSellerUrl(transactionHistory), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    this.setState({ transactionData: response.data.data });
                }
            })
            .catch(error => {
                this.setState({ pageLoading: false });
                // toast.error(error.response.data.message);
            })
    }

    /* calculate total for invoice amount, tax, buyerspremium */
    calculateTotal = () => {
        let amountTotal = 0;
        let taxTotal = 0;
        let taxamountTotal = 0;
        let buyerspremiumTotal = 0;
        let buyerspremiumamountTotal = 0;
        let taxonbuyerspremiumTotal = 0;
        let grossamountTotal = 0;
        this.state.form.items.forEach(item => {
            amountTotal = amountTotal + parseFloat(item.amount);
            taxTotal = taxTotal + parseFloat(item.tax);
            taxamountTotal = taxamountTotal + parseFloat(item.taxamount);
            buyerspremiumTotal = buyerspremiumTotal + parseFloat(item.buyerspremium);
            buyerspremiumamountTotal = buyerspremiumamountTotal + parseFloat(item.buyerspremiumamount);
            taxonbuyerspremiumTotal = taxonbuyerspremiumTotal + parseFloat(item.taxonBPamount);
            grossamountTotal = grossamountTotal + parseFloat(item.grossamount);

        });
        this.setState({
            form: {
                ...this.state.form,
                totaltax: taxTotal ? taxTotal : 0,
                totaltaxamount: taxamountTotal ? taxamountTotal : 0,
                totalbp: buyerspremiumTotal ? buyerspremiumTotal : 0,
                totalbpamount: buyerspremiumamountTotal ? buyerspremiumamountTotal : 0,
                totaltaxonbpamount: this.state.form.applytaxonbp ? (taxonbuyerspremiumTotal ? taxonbuyerspremiumTotal : 0) : 0,
                totalgrossamount: grossamountTotal ? grossamountTotal : 0,
                totalamount: amountTotal ? amountTotal : 0
            }
        });
    }

    /* Send email to user */
    sendEmail = () => {
        this.setState({ emailLoading: true });
        axios.get(getSellerUrl(`${invoiceSendEmail}/${Number(this.state.form.id)}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success')
                    // toast.success('Successful')
                    this.setState({
                        emailLoading: false,
                        invoiceStatus: { show: true, type: 'success', message: 'Email sent successfully' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({ invoiceStatus: { show: false, type: '', message: '' } });
                        }, 3000);
                    });
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    emailLoading: false,
                    invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }
    sendAddonEmail = (addOnId) => {
        this.setState({ addOnEmail: true });
        axios.get(getSellerUrl(`${invoiceSendEmail}/${Number(addOnId)}`), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success')
                    // toast.success('Successful')
                    this.setState({
                        addOnEmail: false,
                        addOnInvoiceStatus: { show: true, type: 'success', message: 'Email sent successfully' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({ addOnInvoiceStatus: { show: false, type: '', message: '' } });
                        }, 3000);
                    });
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    addOnEmail: false,
                    addOnInvoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }
    /* Called when paid modal input changed */
    onPaidInputChange = (event) => {
        let eventValue = event.target.value;
        const name = event.target.name;
        let errors = this.state.errors;
        if (decimalTypes.includes(event.target.name)) {
            let threeDecimal = ['amountpaid'];
            if (threeDecimal.includes(event.target.name)) {
                if (eventValue) {
                    if (eventValue) {
                        eventValue = eventValue
                            .replace(/[^\d.]/g, '')
                            .replace(new RegExp("(^[\\d]{" + 12 + "})[\\d]", "g"), '$1')
                            .replace(/(\..*)\./g, '$1')
                            .replace(new RegExp("(\\.[\\d]{" + 3 + "}).", "g"), '$1');
                    }
                    if (!eventValue.match(/^\d{1,12}(\.$|\.\d{0,3}$|$)/)) {
                        if (isNaN(eventValue))
                            eventValue = '';
                    }
                }
            }
        }
        switch (name) {
            case 'transactionID':
                errors.transactionID =
                    eventValue.length > 45
                        ? 'Maximum 45 characters'
                        : '';
                break;
            case 'amountpaid':
                errors.amountpaid =
                    eventValue.length > 16
                        ? 'Maximum 15 digits'
                        : '';
                break;
            case 'description':
                errors.description =
                    eventValue.length > 100
                        ? 'Maximum 100 characters'
                        : '';
                break;
            default:
                break;
        }
        this.setState({
            paidForm: { errors, [name]: eventValue },
            modalStatus: { show: false, type: '', message: '' }
        });
        this.setState({
            paidForm: {
                ...this.state.paidForm,
                [event.target.name]: eventValue
            }
        }, () => {
            let valid = false;
            valid = this.state.paidForm.amountpaid && this.state.paidForm.transactionID && this.state.paidForm.transactionType ? true : false;
            this.setState({
                paidForm: {
                    ...this.state.paidForm,
                    valid: valid,
                }
            })
        })
    }

    /* Reset paid form */
    resetPaidForm = () => {
        if (!this.state.isPaidData) {
            this.setState({
                paidModal: false,
                paidForm: {
                    transactionType: this.TransactionType[0],
                    paymentType: this.paymentType[0],
                    transactionID: '',
                    amountpaid: '',
                    description: '',
                    valid: false
                },
                modalStatus: { show: false, type: '', message: '' }
            });
        }
        else {
            this.setState({
                paidModal: false,
                modalStatus: { show: false, type: '', message: '' }
            });

        }
    }

    /* called when save clicked on paid modal*/
    submitPaidForm = async () => {
        this.setState({ loading: true });
        // var pendingAmount =Number(this.state.form.invoiceamount) - Number(this.state.paidForm.amountpaid)
        let data = {
            "data": {
                "referencenumber": this.state.paidForm.transactionID,
                "amount": this.state.paidForm.amountpaid,
                "credit": this.state.paidForm.paymentType === this.paymentType[0] ? 1 : 0,
                "paymentmode": this.state.paidForm.transactionType,
                "paymentreference": '' ,
                "status": "completed",
                "partialpayment": 0,
                "comments": this.state.paidForm.description,
                "invoiceid": Number(this.state.form.id),
                "invoiceitemreceiptmethod": this.state.paidForm.receiptmethod
            }
        }
        await axios.post(getSellerUrl(transactionAdd), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successful');
                    this.setState({
                        loading: false,
                        modalStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                ...this.stateCopy,
                                paidModal: false,
                                isPaidData: true,
                                paidForm: {
                                    ...this.state.paidForm,
                                    valid: false
                                },
                                // form: {
                                //     ...this.state.form,
                                //     status: "paid"
                                // },
                                modalStatus: { show: false, type: '', message: '' }
                            }, () => {
                                this.componentDidMount()
                            });
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                const errorResponse = error.response.data;
                this.setState({
                    loading: false,
                    // paidModal: false,
                    modalStatus: { show: true, type: 'danger', message: Array.isArray(errorResponse.message) ? error.response.data['message'][0]['message'] : errorResponse.message }                
                });
                // toast.error(error.response.data['message']);
            })
    }
    makePayementInvoiceCheck(){
        let disable = false;
        
        if(typeof this.state.form.status === "string" && this.state.form.status.toLowerCase() === 'unpaid' && 
           typeof this.state.form.createdtype === "string" && this.state.form.createdtype.toLowerCase() === 'manual' && 
           typeof this.state.form.bidderacceptance === "string" && this.state.form.bidderacceptance.toLowerCase() !== "accepted"){
            disable = true;
        } else {
            // loop child invoice
            for (var i = 0; i < this.state.form.child_invoice.length; i++) {
                var childInvoceData = this.state.form.child_invoice[i];
                if (typeof childInvoceData.invoicestatus === 'string' && childInvoceData.invoicestatus.toLocaleLowerCase() === 'unpaid' &&
                    typeof childInvoceData.createdtype === 'string' && childInvoceData.createdtype.toLowerCase() === 'manual' &&
                    typeof childInvoceData.bidderacceptance == 'string' && childInvoceData.bidderacceptance.toLowerCase() !== 'accepted') {
                    
                    disable = true;
                }
            }

        }

        return disable;

    } 
    invoicePrintPdf = (value) => {
        this.setState({ printPdf: true });
           let childinvoiceid = this.state.form.child_invoice[0]?.id
           let masterinvoiceid = Number(this.state.form.id);
           let invoiceId = childinvoiceid ? [masterinvoiceid, childinvoiceid] : [masterinvoiceid];
           const data = {
            "saleid": this.state.updateInvoiceData.saleid,
            "invoiceid": invoiceId,
            "type": value,
            }
            let config = getSellerHeaders();
            config['responseType'] = 'blob';
             axios.post(getSellerUrl(invoicePrintPdf), JSON.stringify({ data }), config).then((response) => {
                const blob = new Blob( [ response.data ], { type: 'application/pdf' } );
                const fileURL = window.URL.createObjectURL(blob);
                window.open(fileURL, '_blank');
                this.setState({ printPdf: false });
             })

    }

    /* Called when input changes in shipped modal*/
    onShippedInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            shippedForm: {
                ...this.state.shippedForm,
                [event.target.name]: eventValue
            }
        }, () => {
            let valid = false;
            valid = this.state.shippedForm.trackingid ? true : false;
            this.setState({
                shippedForm: {
                    ...this.state.shippedForm,
                    valid: valid
                }
            })
        })
    }
    onChangePaymentType(item) {
        this.setState({
            ...this.state,
            paidForm: {
                ...this.state.paidForm,
                paymentType: item
            }
        })
    }

    /* Reset shipped form */
    resetShippedForm = () => {
        if (!this.state.isShippedData) {
            this.setState({
                shippedModal: false,
                shippedForm: {
                    trackingid: '',
                    description: '',
                    valid: false
                }
            });
        }
        else {
            this.setState({
                shippedModal: false,
            });

        }
    }

    /* Save the shipped modal form */
    submitShippedForm = async () => {
        this.setState({ loading: true });
        let data = {
            "data": {
                "id": Number(this.state.form.id),
                "trackshippingid": this.state.shippedForm.trackingid,
                "shippingnotes": this.state.shippedForm.description,
            }
        };
        await axios.put(getSellerUrl(updateShipping), JSON.stringify(data), getSellerHeaders())
            .then(response => {
                if (response.data.status === 'success') {
                    // toast.success('Successful');
                    this.setState({
                        loading: false,
                        modalStatus: { show: true, type: 'success', message: 'Saved' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                shippedModal: false,
                                isShippedData: true,
                                shippedForm: {
                                    ...this.state.shippedForm,
                                    valid: false
                                },
                                modalStatus: { show: false, type: '', message: '' },
                                DisplayTrackingid: this.state.shippedForm.trackingid
                            });
                        }, 3000);
                    });
                }
            })
            .catch(error => {
                this.setState({
                    loading: false,
                    shippedModal: false,
                    modalStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
                // toast.error(error.response.data['message']);
            })
    }

    /*Print invoice when clicked print */
    print = () => {
        const printableElements = document.getElementById('invoiceGenration').innerHTML;
        const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
        const oldPage = document.body.innerHTML;
        document.body.innerHTML = orderHtml;
        window.print();
        window.location.reload();
        document.body.innerHTML = oldPage;
        // window.location.reload();
        // document.body.innerHTML = oldPage;
    }
    async updateInvoice() {
        this.setState({ updateLoading: true });
        await axios.post(getSellerUrl(updateInvoice), { data: this.state.updateInvoiceData }, getSellerHeaders())
            .then(response => {
                // toast.success('Updated successfully');
                this.setState({
                    updateLoading: false,
                    invoiceStatus: { show: true, type: 'success', message: 'Saved' }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            invoiceStatus: { show: false, type: '', message: '' }
                        }, () => this.props.history.push('/invoice'));
                    }, 3000);
                });
            })
            .catch(error => {
                // toast.error(error.response.data.message);
                this.setState({
                    updateLoading: false,
                    invoiceStatus: { show: true, type: 'danger', message: error.response.data['message'] }
                });
            });
    }

    navigateToList = () => {
        const { mirstatus, dgstatus } = this.state;
        const state = this.props.location.state;
        if (this.state.childInvoice !== "") {
            this.props.history.push({ pathname: `/invoice/view/${this.state.childInvoice}`, state: state })
            this.setState({
                form: {
                    ...this.state.form,
                    id: this.state.childInvoice
                },
                childInvoice: "",
            }, () => {
                this.componentDidMount()
            })
            return true
        }
        if (!state) {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
        else if (this.props?.location?.state?.name === "Saledashboard") {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: state })
        }
        else if (state?.name === "Invoice") {
            this.props.history.push({ pathname: '/invoice', state: this.props.location.state })
        }
        else if (mirstatus) {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: this.props.location.state })
        } else if (dgstatus) {
            this.props.history.push({ pathname: this.props.location.state.prevPath, state: this.props.location.state })
        } else {
            this.props.history.goBack();
        }
    };
    navigateToParentInvoice = () => {
        const state = this.props.location.state;
        this.props.history.push({ pathname: `/invoice/view/${this.state.form.masterId}`, state: state })
        this.setState({
            childInvoice: this.state.form.id,
            form: {
                ...this.state.form,
                id: this.state.form.masterId
            },
        }, () => {
            this.componentDidMount()
        })

    }
    onNavigateToCreate() {
        const state = {
            ...this.props.location.state,
            status: this.state.form.status,
            isPaidCreate: true
        }
        this.props.history.push({ pathname: `/invoice/edit/${this.state.form.id}`, state })
    }
    captializeLetter = (data) => {
        const capitalized = data.charAt(0).toUpperCase() + data.slice(1);
        return capitalized;
    }
    onChangeOption = (event) => {
        this.setState({
            itemReceiptValue: (event.target.value).toLowerCase(),
        })
    }
    editIrm = () => {
        this.setState({
            irmModel: true
        })
    }
    
    confirmIrmMethod = () => {
        this.setState({
            validirm: true
        })
        const data = {
            "invoiceItemReceiptMethod": this.state.itemReceiptValue,
            "buyerid": this.state.updateInvoiceData.buyerid
        }
        axios.post(getSellerUrl(`${invoiceitemreceiptmethod}/${Number(this.state.form.id)}`),{ data: data}, getSellerHeaders())
            .then((response) => {
                if (response.status === 200) {
                    response = response.data.data[0];

                }
                this.setState({
                    irmModel: false
                })
            })
            .catch((error) => {
                this.setState({
                    irmModel: false
                })
            });
            setTimeout(() => {
                this.getInvoiceData()
                this.setState({
                    validirm: false
                })
            }, 1000);
    }
    closeConfirmModal = () =>  {
        this.setState({
            irmModel: false
        })
    }
    

    getTransactionMessage = (data) => {
        try {
            if(data) {
                let parsedData = JSON.parse(data) ? JSON.parse(data) : data;
                parsedData = parsedData?.data ? parsedData?.data : parsedData
                let responseCode = parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.processor_response?.response_code : 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status ? 
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status : 
                    parsedData?.name ? parsedData?.name : 
                    parsedData?.resource?.status ? parsedData?.resource?.status :
                    parsedData?.resource?.processor_response?.response_code    

                let message = 
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "COMPLETED" ? "APPROVED" :
                    responseCode == "0000" && parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status == "DECLINED" ? parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "ECHECK" ? responseCodeAndStatus?.["ECHECK"] :
                    parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason === "PENDING_REVIEW" ? responseCodeAndStatus?.["PENDING"] :
                    responseCode == "PENDING" ?  parsedData?.purchase_units?.[0]?.payments?.captures?.[0]?.status_details?.reason : 
                    parsedData?.name == 'UNPROCESSABLE_ENTITY' ? parsedData?.details[0]?.description : 
                    // (parsedData == "INTERNAL_SERVER_ERROR" || parsedData.name == "INTERNAL_SERVER_ERROR") ? 'PayPal Payment Gateway currently unavailable: This payment could not be processed at this time. Please try again later.' : 
                    (parsedData?.code === 500 ||  parsedData?.name == 'GATEWAY_TIMEOUT' || parsedData?.code === 502 || parsedData == "INTERNAL_SERVER_ERROR" || parsedData?.name == "INTERNAL_SERVER_ERROR"|| parsedData == "error code: 502" || parsedData == "error code: 500") ? 
                    responseCodeAndStatus?.["500"] :
                    parsedData?.status == "PAYER_ACTION_REQUIRED" ? "Payer Action Required - Call Customer to discuss required actions from financial institution." :
                    responseCode == "PPAB" ? "ACCOUNT_BLOCKED_BY_ISSUER" :
                    responseCode == "DECLINED" ? responseCodeAndStatus?.['CTBHD'] : 
                    responseCode == "COMPLETED" ? "Payment approved and completed" : 
                    parsedData?.message ? parsedData.message : responseCode ? `${responseCode} - ${responseCodeAndStatus?.[responseCode]}` : responseCodeAndStatus?.['CTBHD'];
                
                return message ? message : "---"
            } 
        } catch (err) {
            //handle err
        }
        return responseCodeAndStatus?.['CTBHD'];
    }

    navigateToFullfillment = (id) => {
        const state = { ...this.props.location.state }; 
        state["invoiceId"] = id
        state["buyerid"] = this.state.updateInvoiceData.buyerid
        state["saleshippingsaint"] = this.state.form.saleshippingsaint
        this.props.history.push({ pathname: `/fulfillment/${id}`, state: state })
    }

    render() {
        const { errors } = this.state;
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Invoiceid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div style={{ overflow: "auto", overflowY: "overlay" }}>
                {this.state.loading ?
                    <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100" style={{ padding: "30%" }}>
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                    <div className="invoiceView container h-90 mt-3" style={{ width: this.state.windowWidth > 425 ? '85%' : '100%' }}>
                        <div className='no-print'>
                            {
                                this.state.form.status.toLowerCase() !== 'void' ?
                                    <div className="d-flex">
                                        <div className="justify-content-start text-left" style={{ width: "45%" }}>
                                            <Button onClick={() => { this.navigateToList() }} style={{ backgroundColor: '#A50050' }}><i className="fa fa-chevron-left"></i> Back</Button>
                                            {(this.state.form.status.toLowerCase() !== 'paid' || this.state.form.child_invoice.filter((data) => { return data.invoicestatus.toLowerCase() !== 'paid' }).length > 0) &&
                                                <Button type="button" className="btn-success m-1" disabled={this.makePayementInvoiceCheck() || this.state.form?.autoDebitStatus.toLowerCase() == 'pending'} onClick={() => {
                                                    this.setState({
                                                        paidModal: true,
                                                        paidForm: {
                                                            transactionType: this.TransactionType[0],
                                                            transactionID: '',
                                                            amountpaid: '',
                                                            description: '',
                                                            paymentType: this.paymentType[0],
                                                            valid: false,
                                                            receiptmethod: this.invoiceItemReceiptMethod ? this.invoiceItemReceiptMethod : ''
                                                        }
                                                    })
                                                }}>Make Payment</Button>
                                            }
                                            <Button type="button" className="btn-white m-1" onClick={() => {this.navigateToFullfillment(this.state.form.invoiceViewId)}} disabled={this.state.form.saleshippingsaint ? false : (this.state.form.status.toLowerCase() != "paid" || (this.state.shippingCheckboxData.length == 0 && (this.state.pickupCheckboxData.length > 0 || this.state.deliveryCheckboxData.length > 0)))}>Fulfillment</Button>
                                            {/* <Button type="button" className="btn-white m-1" onClick={() => this.setState({ shippedModal: true })} disabled={this.state.invoiceStatus.type === 'success' || this.state.form.status.toLowerCase() !== 'paid' || this.state.form.invoiceitemreceiptmethod === "" || this.state.form.invoiceitemreceiptmethod.toLowerCase() === "pickup" || this.state.form.invoiceitemreceiptmethod.toLowerCase() === "delivery"}>{this.state.isShippedData ? 'Shipped' : 'Fullfillment'}</Button> */}
                                            <Button type="button" className="btn-white m-1" onClick={() => this.setState({ transactionModal: true })}>Transaction History</Button>
                                        </div>
                                        <div className=" text-end" style={{ width: "15%" }}>
                                            {/* {
                                                this.state.invoiceStatus.show ?
                                                    <ToasterMessage type={this.state.invoiceStatus.type} message={this.state.invoiceStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                                    : null
                                            } */}
                                        </div>
                                        <div className="justify-content-end text-right" style={{ width: "40%" }}>
                                        {/* {(this.state.form.status.toLowerCase() === 'unpaid') &&< Button disabled={this.state.validirm || this.itemReceiptMethods.length <= 1 } className="btn" onClick={() => this.editIrm()}>Edit Item Receipt Method</Button>} */}
                                            {(this.state.form.status.toLowerCase() === 'paid') && <Button
                                                onClick={() => { this.onNavigateToCreate() }}
                                                className="save-button m-1" disabled={this.state.form.child_invoice.length >= 1}>+ Create Add On Invoice</Button>}
                                            {/* <Button className="btn-white m-1" onClick={() => this.sendEmail()} disabled={this.state.invoiceStatus.type === 'success'}>Send Email {' '} {this.state.emailLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button> */}
                                            <Button className="btn-dark m-1" onClick={() => this.invoicePrintPdf("print")}>Print {this.state.printPdf ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                            {this.props.location.state !== undefined && this.props.location.state.name === "Saledashboard" && this.state.form.enableEdit && <Button
                                                className="btn ml-1" style={{ backgroundColor: "#7f1b34" }} disabled={this.state.form?.autoDebitStatus.toLowerCase() == 'pending'} 
                                                onClick={() => {
                                                    this.props.history.push({
                                                        pathname: `/invoice/edit/${this.state.form.invoiceViewId}`,
                                                        state: { ...this.props.location.state },
                                                    });
                                                }}
                                                >Edit Invoice
                                            </Button>}


                                            {/* <Button className="btn-secondary m-1" onClick={()=>this.updateInvoice()} disabled={ this.state.form.status.toLowerCase() === 'paid' || this.state.invoiceStatus.type === 'success'  ? true : false }>Update Invoice {' '} {this.state.updateLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button> */}
                                        </div>
                                    </div>
                                    :
                                    <div >
                                        <Button onClick={() => { this.navigateToList() }}><i className="fa fa-chevron-left"></i> Back</Button>
                                        {/* <div className=" d-flex flex-row justify-content-end text-end" style={{ float: "right" }}>
                                            {
                                                this.state.invoiceStatus.show ?
                                                    <ToasterMessage type={this.state.invoiceStatus.type} message={this.state.invoiceStatus.message} style={{ marginLeft: "900px" }} className="alert-handle mt-2"></ToasterMessage>
                                                    : null
                                            }
                                            <Button className="btn-white " onClick={() => this.sendEmail()} disabled={this.state.invoiceStatus.type === 'success'}>Send Email {' '} {this.state.emailLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                        </div> */}
                                    </div>

                            }
                        </div>
                        <div className="invoiceBorder">
                            <div className="print" id="invoiceGenration">
                                <div className={`d-flex ${this.state.windowWidth > 800 ? "flex-row" : ""} p-4 border-bottom ${this.state.windowWidth > 800 ? '' : 'row'}`}>
                                    <div className={` ${this.state.windowWidth > 800 ? 'justify-content-left text-left w-50' : 'justify-content-center text-center'} col-md-6 col-xs-12`}>
                                        <img src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`} alt="logo" height="60px" width="170px" />
                                        {/* {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                            <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>} */}
                                        {this.state.form.status === 'paid' && <span className="text-success"><i className={`fa ${this.status[this.state.form.status]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status}</span>}
                                    </div>
                                    <div className={`${this.state.windowWidth > 800 ? 'justify-content-end text-right w-50 mt-3' : 'justify-content-center text-center mt-1'}  col-md-6`}>
                                        {this.state.DisplayTrackingid ?
                                            <div className={` text-secondary col-xs-12`}><div style={{ fontSize: "20px", whiteSpace: 'nowrap' }}>Tracking Id: {this.state.DisplayTrackingid ? this.state.DisplayTrackingid : "  - - -"}</div></div> : ""
                                        }
                                        { this.state.form.invoiceitemreceiptmethod && this.state.invoiceview?
                                            <span className="h4">Item Receipt Method: {this.state.form.invoiceitemreceiptmethod ? capitalizeFirstLetter(this.state.form.invoiceitemreceiptmethod) : "  - - -"}</span> : ""
                                        }
                                    </div>
                                </div>
                                <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  border-bottom mx-0`}>
                                    <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                        <p><b className="text-secondary"> Billing To </b></p>
                                        {Object.keys(this.state.form.billingto).map((key) =>
                                            key === 'name' ? <p><b>{this.state.form.billingto[key]}</b></p> :
                                                key === 'phonenumber' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingto[key]}</p> : '' :
                                                    key === 'email' ? this.state.form.billingto[key] ? <p style={{ color: "#1d9aa5",wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p> : '' : <p style={{ wordBreak: 'break-all' }}>{this.state.form.billingto[key]}</p>
                                        )}
                                    </div>
                                    <div className={`col col-xs-12 padding ${this.state.form.shippingto.showShippingAddress ? 'col-md-4' : 'col-md-6'}`}>
                                        <p><b className="text-secondary">Pickup Location</b></p>
                                        {Object.keys(this.state.form.billingfrom).map((key) =>
                                            key === 'contactname' ? <p><b>{this.state.form.billingfrom[key]}</b></p> :
                                                key === 'contactmobile' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>Phone No: {this.state.form.billingfrom[key]}</p> : '' :
                                                    key === 'contactemail' ? this.state.form.billingfrom[key] ? <p style={{ color: "#1d9aa5" }}>{this.state.form.billingfrom.contactemail} </p> : '' : <p>{this.state.form.billingfrom[key]}</p>
                                        )}
                                    </div>
                                    {this.state.form.shippingto.showShippingAddress ? <div className="col col-md-4 col-xs-12 padding">
                                        <p><b className="text-secondary">Shipping To</b></p>
                                        {Object.keys(this.state.form.shippingto).map((key) =>
                                            <p style={{ wordBreak: 'break-all' }}>{this.state.form.shippingto[key]}</p>
                                        )}
                                    </div> : ''}
                                </div>
                                <div className={` p-4 border-bottom mx-0`}>
                                    <div style={{ fontSize: "20px" }}><p><b className="text-secondary">Invoice Details</b></p>
                                    </div>
                                </div>
                                <div className={`${this.state.windowWidth > 800 && "d-flex row"} p-4  mx-0`}>

                                    <div className="col  col-xs-12 padding"><div >
                                        <p className={` text-secondary col-xs-12`} ><b style={{ fontSize: "20px" }}>Invoice: {this.state.form.invoicenumber}    </b>
                                        {<span className={`${this.state.form.status.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                            <i className={`fa ${this.status[this.state.form.status.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{this.state.form.status.toUpperCase()}</span>}</p></div></div>
                                            <div className=" d-flex flex-row justify-content-end text-end" >
                                            {
                                                this.state.invoiceStatus.show ?
                                                    <ToasterMessage type={this.state.invoiceStatus.type} message={this.state.invoiceStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                                    : null
                                            }
                                        </div>
                                    <div className="col col-xs-12 padding" style={{ textAlign: "right" }}>
                                        <p><b className="text-secondary">Invoice Date :- </b><b>{moment.utc(this.state.form.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                         <Button className="btn-white " style={{border: "1px solid #A50050"}} onClick={() => this.sendEmail()} disabled={this.state.invoiceStatus.type === 'success'}>Send Email {' '} {this.state.emailLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                    </div>
                                </div>
                                { this.state.form.items.length !== 0  ? <div style={{ overflowX: "auto" }} className={` p-4 border-bottom mx-0`}>
                                    {this.state.form.items.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                        <thead>
                                            <tr style={{ color: "#A50050", flexWrap: "nowrap" }}>
                                                <td style={{ paddingLeft: "2.5rem" }}>Items</td>
                                                <td>SKU</td>
                                                {!this.state.invoiceview ? <td>IRM</td> : null}
                                                <td>Amount</td>
                                                <td>Tax</td>
                                                <td>Tax Amount</td>
                                                <td>BP</td>
                                                <td>BP Amount</td>
                                                {this.state.form.applytaxonbp ? <td>BP Tax Amount</td> : ''}

                                                <td style={{ paddingRight: "0.5rem" }}>Gross Amount</td>
                                            </tr>
                                        </thead>                             
                                        <tbody>
                                            {
                                                this.state.form.items.map((item, index) => (
                                                    <tr>
                                                        <td style={{ paddingLeft: "2.5rem",width: '25%'}}><a href={item.itemviewurl ? item.itemviewurl : `${buyerlinkurl}${this.state.updateInvoiceData.saleid}/item/${item.id}`} target="_blank">{item.title}</a></td>
                                                        <td style={{ wordBreak: 'break-all' }}>{item.SKU ? item.SKU : "- - -"}</td>
                                                        {!this.state.invoiceview ? <td style={{ whiteSpace: "nowrap"}}>{item.bidderirm ? capitalizeFirstLetter(item.bidderirm) : '- - -' }</td> : null}
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.tax ? `${item.tax} %` : '- - -'}</td>
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.taxamount ? `$ ${parseFloat(item.taxamount).toFixed(2)}` : '- - -'}</td>
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremium ? `${item.buyerspremium} %` : '- - -'}</td>
                                                        <td style={{ whiteSpace: "nowrap" }}>{item.buyerspremiumamount ? `$ ${parseFloat(item.buyerspremiumamount).toFixed(2)}` : '- - -'}</td>
                                                        {this.state.form.applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>{item.taxonBPamount ? `$ ${parseFloat(item.taxonBPamount).toFixed(2)}` : '- - -'}</td> : ''}
                                                        <td style={{ paddingRight: "2.5rem", whiteSpace: "nowrap" }}>{item.grossamount ? `$ ${parseFloat(item.grossamount).toFixed(2)}` : '- - -'}</td>
                                                    </tr>
                                                ))
                                            }
                                             <tr style={{ fontWeight: "bold", flexWrap: "nowrap" }}>
                                                        <td></td>
                                                        {!this.state.invoiceview ? <td></td> : null}
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalamount).toFixed(2)}</td>
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }} >$ {parseFloat(this.state.form.totaltaxamount).toFixed(2)}</td>
                                                        <td></td>
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalbpamount).toFixed(2)}</td>
                                                        {this.state.form.applytaxonbp ? <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totaltaxonbpamount).toFixed(2)}</td> : ''}
                                                        <td style={{ whiteSpace: "nowrap" }}>$ {parseFloat(this.state.form.totalgrossamount).toFixed(2)}</td>
                                                    </tr>

                                        </tbody>
                                    </Table>
                                    }
                                </div> :
                                    <div className="serviceview" style={{ padding: '0 1% 0 1%' }}>
                                        <Table className="amountfields" responsive style={{ height: "100%" }}>
                                            <thead>
                                                <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                    <td style={{ textAlign: "left" }}>Services</td>
                                                    <td style={{ textAlign: "left" }}>Description</td>
                                                    <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>Amount</td>
                                                </tr>
                                            </thead>
                                            {this.state.form.selectedService.map((item, index) => (
                                                <tr>
                                                    <td style={{ textAlign: "left", width: "30%" }}>{item.name}</td>
                                                    <td style={{ textAlign: "left", width: "45%" }}>{item.remark ? item.remark : "- - -"}</td>
                                                    <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                </tr>
                                            ))}
                                            
                                        </Table>
                                        <Row className="" >
                                            <Col></Col>
                                            <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.invoiceamount ? `$ ${parseFloat(this.state.form.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                        </Row>
                                    </div>}
                                <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""} , p-4 border-bottom mx-0`} style={{ margin: "2% 5%" }}>
                                    {this.state.additionalnotes ? <p><b className="text-secondary" style={{ paddingLeft: "15px" }}> Additional Notes </b>{ this.state.additionalnotes ?
                                        <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.state.additionalnotes}</Tooltip>}>
                                            <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                        </OverlayTrigger> : ""}
                                        <div className={this.state.additionalnotes ? 'viewonlyinprint' : ''}>
                                            {this.state.additionalnotes}
                                        </div>
                                    </p> : '' 
                                    }   
                                    { this.state.form.items.length !== 0  ?
                                        <div className="serviceview" >
                                        {this.state.form.selectedService.map((item, index) => (
                                            <Row className="">
                                                <Col className="text-left text-secondary" ><b>{item.name}</b></Col>
                                                <Col>{item.remark ? item.remark : '- - -'}</Col>
                                                <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</b></Col>
                                            </Row>
                                        ))}
                                        <Row className="" >
                                            <Col></Col>
                                            <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                            <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{this.state.form.invoiceamount ? `$ ${parseFloat(this.state.form.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                        </Row>

                                    </div> : ''}
                                </div>
                                <div className={` p-4 mx-0`}>
                                    {this.state.form.child_invoice &&
                                        this.state.form.child_invoice.map((data, key) => (
                                            <div className=" h-20 mt-1" >
                                                <div className="">
                                                    <div className="print" >
                                                        <div className="childInvoice pagebreak" >
                                                            <div className={`${this.state.windowWidth > 800 && "d-flex row"} `}>
                                                                <div className="col col-xs-12 padding">
                                                                    <div className="text-secondary"><b style={{ fontSize: "20px" }}>Invoice: {data.invoicenumber} </b>    {<span className={`${data.invoicestatus.toLowerCase() === 'paid' ? "text-success" : "text-danger"}`}>
                                                                        <i className={`fa ${this.status[data.invoicestatus.toLowerCase()]} fa-lg pr-2 pt-1`} aria-hidden="true"></i>{data.invoicestatus.toUpperCase()}</span>}
                                                                    </div>
                                                                </div>
                                                                <div className=" d-flex flex-row justify-content-end text-end">
                                                                    {
                                                                        this.state.addOnInvoiceStatus.show ?
                                                                            <ToasterMessage type={this.state.addOnInvoiceStatus.type} message={this.state.addOnInvoiceStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                                                            : null
                                                                    }
                                                                </div>
                                                                <div className="col  col-xs-12 padding" style={{ textAlign: "right" }}>
                                                                    <p><b className="text-secondary">Invoice Date :- </b> <b> {moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} {momentTz.tz(momentTz.tz.guess()).zoneAbbr()}</b></p>
                                                                <Button className="btn-white" style={{border: "1px solid #9f2241"}} onClick={() => this.sendAddonEmail(data.id)} disabled={this.state.addOnInvoiceStatus.type === 'success'}>Send Email {' '} {this.state.addOnEmail ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>

                                                                </div>
                                                            </div>
                                                            <div className={`${this.state.windowWidth > 800 ? "d-flex flex-column-reverse" : ""}`} >
                                                                {data.additionalnotes ? <p><b className="text-secondary" style={{ paddingLeft: "15px" }}> Additional Notes </b> { data.additionalnotes ? 
                                                                    <OverlayTrigger className="no-print" trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{data.additionalnotes}</Tooltip>}>
                                                                        <i className={`fa fa-question-circle no-print`} style={{ fontSize: "14px" }}></i>
                                                                    </OverlayTrigger> : '' }
                                                                    <div className={data.additionalnotes ? 'viewonlyinprint' : ''}>
                                                                        {data.additionalnotes}
                                                                    </div>
                                                                </p> : ''}
                                                                <div className="serviceview" >
                                                                    <div >
                                                                        {data.selectedService.length > 0 && <Table className="amountfields" responsive style={{ height: "100%" }}>
                                                                            <thead>
                                                                                <tr style={{ color: "#9F2241", flexWrap: "nowrap" }}>
                                                                                    <td style={{ textAlign: "left"}}>Services</td>
                                                                                    <td style={{ textAlign: "left"}}>Description</td>
                                                                                    <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>Amount</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    data.selectedService.map((item, index) => (
                                                                                        <tr>
                                                                                            <td style={{ textAlign: "left", width: "30%"}}>{item.name}</td>
                                                                                            <td style={{ textAlign: "left", width: "45%" }}>{item.remark ? item.remark : "- - -"}</td>
                                                                                            <td style={{ textAlign: "right", paddingRight: "1.5rem" }}>{item.amount ? `$ ${parseFloat(item.amount).toFixed(2)}` : '- - -'}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                }

                                                                            </tbody>
                                                                        </Table>
                                                                        }
                                                                    </div>
                                                                    <Row className="" >
                                                                        <Col></Col>
                                                                        <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b>{data.invoiceamount ? `$ ${parseFloat(data.invoiceamount).toFixed(2)}` : '- - -'}</b></Col>
                                                                    </Row>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                <div className="serviceview">
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Total Amount</b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoiceAmount ? `$ ${parseFloat(this.state.form.totalInvoiceAmount).toFixed(2)}` : '- - -'}</b></Col>
                                    </Row>
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Payments Received </b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoiceAmountPaid ? `$ ${parseFloat(this.state.form.totalInvoiceAmountPaid).toFixed(2)}` : '- - -'}</b></Col>
                                    </Row>
                                    <Row className="" >
                                        <Col></Col>
                                        <Col className="text-right text-secondary" ><b>Remaining Amount Due </b></Col>
                                        <Col style={{ paddingLeft: this.state.windowWidth > 430 ? "3px" : "7px" }} className="text-end text-secondary"><b style={{ paddingRight: "10%" }}>{this.state.form.totalInvoicePendingAmount ? `$ ${parseFloat(this.state.form.totalInvoicePendingAmount).toFixed(2)}` : '- - -'}</b></Col>
                                    </Row>
                                </div>

                                <div className="px-5 py-4 invoice-message-wraper" style={{ textAlign: "justify" }} dangerouslySetInnerHTML={{ __html: this.state.form.invoicemessage }}>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <Modal centered show={this.state.irmModel} id="" animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <>
                            <h5 className="text-secondary  text-center text-bold">Select Item Receipt Method</h5>

                            <Form.Group className="d-flex center-align mt-3" style={{ justifyContent: 'center' }}>
                                {this.itemReceiptMethods.map((value, index) => {
                                    return value && <Form.Check custom type="radio" style={{ marginRight: "10px" }} id={value} name="invoiceItemReceipt" label={this.captializeLetter(value)} value={value ? value : ''} onChange={(event) => this.onChangeOption(event)} />
                                })}
                            </Form.Group>
                            <div className="d-flex align-items-center justify-content-center mt-4 actions">
                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.closeConfirmModal()}>Cancel</Button>
                                <Button variant="secondary mx-2" onClick={() => this.confirmIrmMethod()} disabled={this.state.itemReceiptValue === ""} >
                                    Confirm
                                </Button>
                            </div>
                        </>
                    </Modal.Body>
                </Modal>

                <Modal centered show={this.state.paidModal} id="paidModal">
                    <Modal.Body>
                        <h5 className="text-secondary">Make Payment</h5>
                        <Form>
                            <div className="amount float-control" >
                                <span className="float-control">
                                    <Form.Control type="text" id="transactionID" name="transactionID" placeholder=" " value={this.state.paidForm.transactionID} className={this.state.paidForm.trackshippingid ? 'form-control-active' : ''} onChange={(event) => this.onPaidInputChange(event)} />
                                </span>
                                <label htmlFor="transactionID" className="required">Transaction ref Number</label>
                                {errors.transactionID.length > 0 &&
                                    <small className='paymenterror'>{errors.transactionID}</small>}
                            </div>

                            <div style={{ flexDirection: "row", justifyContent: "center", borderWidth: 1, borderLeftColor: "#ced4da", width: "100%", border: "1px solid rgb(206, 212, 218)", padding: "6px", marginBottom: "11px", borderRadius: "4px" }}>
                                {this.paymentType.map((item, index) => (
                                    <div className="invoice-payment-type" style={{ width: "45%" }} >
                                        <div onClick={() => { this.onChangePaymentType(item) }} className="radio-button-outer">
                                            {item === this.state.paidForm.paymentType && <div className="radio-button-inner"></div>}
                                        </div>
                                        <div className="invoice-payment-type-text">{item}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="float-control" >
                                <Form.Control as="select" id="transactionType" name="transactionType" value={this.state.paidForm.transactionType} className={this.state.paidForm.transactionType ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.onPaidInputChange(event)}>
                                    <option style={{ display: "none" }} selected>Add Transaction Type</option>
                                    {this.TransactionType.map((type, index) =>
                                        <option key={index} value={type}>{type}</option>
                                    )}
                                </Form.Control>
                                <Form.Label htmlFor="transactionType" className="required">Add Transaction Type</Form.Label>
                            </div>
                            {
                                this.itemReceiptMethods.length > 0 && this.state.invoiceview ?
                                    <div className="float-control" >
                                        <Form.Control as="select" id="receiptmethod" name="receiptmethod" value={this.state.paidForm.receiptmethod} className={this.state.paidForm.receiptmethod ? 'form-control-active' : ''} placeholder=" " onChange={(event) => this.onPaidInputChange(event)}>
                                            <option disabled={this.state.paidForm.receiptmethod ? true : false}>Select Item Receipt Method</option>
                                            {this.itemReceiptMethods.map((type, index) =>
                                                <option key={index} value={type}>{type}</option>
                                            )}
                                        </Form.Control>
                                        <Form.Label htmlFor="receiptmethod" >Item Receipt Method</Form.Label>
                                    </div> : ''
                            }
                            <div className="amount float-control" >
                                <span className="currency">
                                    <Form.Control type="text" id="amountpaid" name="amountpaid" placeholder=" " value={this.state.paidForm.amountpaid} className={this.state.paidForm.amountpaid ? 'form-control-active' : ''} onChange={(event) => this.onPaidInputChange(event)} />
                                </span>
                                <label htmlFor="amountpaid" className="required">Amount Paid</label>
                                {errors.amountpaid.length > 0 &&
                                    <small className='paymenterror'>{errors.amountpaid}</small>}
                            </div>
                            <div>
                                <Form.Control as="textarea" id="description" name="description" placeholder="Manual Payment" value={this.state.paidForm.description} className={this.state.paidForm.description ? 'form-control-active' : ''} onChange={(event) => this.onPaidInputChange(event)} />
                                {errors.description.length > 0 &&
                                    <small className='errordescription'>{errors.description}</small>}
                            </div>
                            <div className="mt-3">
                                <div className="d-flex flex-row justify-content-center text-center">
                                    {
                                        this.state.modalStatus.show ?
                                            <ToasterMessage type={this.state.modalStatus.type} message={this.state.modalStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <div className="d-flex justify-content-center text-center">
                                    <Button onClick={() => this.resetPaidForm()} className="btn-white">Cancel</Button>
                                    <Button onClick={() => this.submitPaidForm()} disabled={!this.state.paidForm.valid || this.state.modalStatus.show || this.state.loading} className="btn-secondary ml-2">Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                <Modal centered show={this.state.shippedModal} id="shippedModal">
                    <Modal.Body>
                        <h5 className="text-secondary">Mark Shipped</h5>
                        <Form>
                            <div className="float-control">
                                <Form.Control type="text" id="trackingid" name="trackingid" placeholder=" " value={this.state.shippedForm.trackingid} className={this.state.shippedForm.trackingid ? 'form-control-active' : ''} onChange={(event) => this.onShippedInputChange(event)} disabled={this.state.isShippedData} />
                                <label htmlFor="trackingid" className="required">Tracking Id</label>
                            </div>
                            <div>
                                <Form.Control as="textarea" id="description" name="description" placeholder="Add Description" value={this.state.shippedForm.description} className={this.state.shippedForm.description ? 'form-control-active' : ''} onChange={(event) => this.onShippedInputChange(event)} disabled={this.state.isShippedData} />
                            </div>
                            <div className="mt-2">
                                <div className="d-flex flex-row justify-content-center text-center">
                                    {
                                        this.state.modalStatus.show ?
                                            <ToasterMessage type={this.state.modalStatus.type} message={this.state.modalStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                            : null
                                    }
                                </div>
                                <div className="d-flex justify-content-center">
                                    <Button onClick={() => this.resetShippedForm()} className="btn-white">Cancel</Button>
                                    <Button onClick={() => this.submitShippedForm()} disabled={!this.state.shippedForm.valid || this.state.modalStatus.show || this.state.loading} className="btn-secondary ml-2">Save {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                </div>
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>
                <Modal size="xl" id="transactionModal" show={this.state.transactionModal} centered onHide={() => this.setState({ transactionModal: false })}>
                    <Modal.Header closeButton>
                        <h5 className="text-secondary"><b>Transaction History</b></h5>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{overflowX: 'scroll'}} >
                        <table  className="table">
                            <tbody>
                                <tr className=" header" >
                                    <td>Ctbids Transaction Id</td>
                                    <td>Date</td>
                                    <td>Invoice Number</td>
                                    <td>Transaction Type</td>
                                    <td>Payment Mode</td>
                                    <td>PayPal Transaction ID</td>
                                    <td>PayPal Status</td>
                                    <td>Amount</td>
                                    <td>Notes</td>
                                    <td>Response Code</td>
                                </tr>
                                {this.state.transactionData.length ?
                                    this.state.transactionData.map(data =>
                                        <tr>
                                            <td>{data.referencenumber ? data.referencenumber : '- - -'}</td>
                                            <td style={{whiteSpace: "nowrap"}}>{data.createddate ? `${moment.utc(data.createddate).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}` : '- - -'}</td>
                                            <td>{data.invoicenumber ? data.invoicenumber : '- - -'}</td>
                                            <td>{data.credit ? 'Credit' : ''}</td>
                                            <td>{data.paymentmode ? data.paymentmode : '- - -'}</td>
                                            <td>{data.paymentreference ? data.paymentreference : '- - -'}</td>
                                            <td>{data.paypalstatus ? data.paypalstatus.toLowerCase() : data.status ? data.status.toLowerCase() : '- - -' }</td>
                                            <td style={{whiteSpace: "nowrap"}}>{data.amount ? `$ ${data.amount.toFixed(2)}` : '- - -'}</td>
                                            <td style={{ wordWrap: 'break-word' }}>{data.comments ? data.comments : 'Manual payment'}</td>
                                            <td>{data.tranresponse ? 
                                                <div>
                                                    <OverlayTrigger trigger={['hover', 'focus']} overlay={<Tooltip id="tooltip-clone" style={{ visibility: 'visible' }}>{this.getTransactionMessage(data.tranresponse)}</Tooltip>}>
                                                        <i className={`fa fa-question-circle`} style={{ fontSize: "14px" }}></i>
                                                    </OverlayTrigger>
                                                </div> : '- - -' }
                                            </td>
                                        </tr>
                                    ) :
                                    <tr><td colSpan="10"><h5 className="noData" >No data available</h5></td></tr>
                                }
                            </tbody>
                        </table>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}